import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import "regenerator-runtime/runtime";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import { useEffect } from 'react';
import { useObjectMemo } from '@hon2a/use-object-memo';
import useAsyncFn from 'react-use/lib/useAsyncFn';
import { loadIntercom, startIntercom, stopIntercom, updateIntercom } from './intercom';
export var useIntercom = function useIntercom(appId) {
  var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var settingsMemo = useObjectMemo(settings);

  var _useAsyncFn = useAsyncFn(function _callee() {
    return _regeneratorRuntime.async(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _regeneratorRuntime.awrap(loadIntercom(appId));

          case 2:
            startIntercom(appId, settingsMemo);
            return _context.abrupt("return", true);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    });
  }, [appId, settingsMemo]),
      _useAsyncFn2 = _slicedToArray(_useAsyncFn, 2),
      _useAsyncFn2$ = _useAsyncFn2[0],
      isLoading = _useAsyncFn2$.loading,
      isStarted = _useAsyncFn2$.value,
      loadAndStart = _useAsyncFn2[1];

  useEffect(function () {
    if (!appId) {
      if (isStarted) stopIntercom();
      return;
    }

    if (isStarted) {
      updateIntercom(settingsMemo);
    } else if (!isLoading) {
      loadAndStart();
    }
  }, [appId, settingsMemo]);
};